import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Translation, TranslocoLoader } from '@ngneat/transloco';
import { TRANSLATION_HASHES } from 'app/core/i18n/translation-hashes';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
    private _httpClient = inject(HttpClient);

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get translation
     *
     * @param lang
     */
    getTranslation(lang: string): Observable<Translation> {
        // The URL changes only when the file does, so a deploy never leaves the browser on the old JSON.
        const hash = TRANSLATION_HASHES[lang];
        const version = hash ? `?v=${hash}` : '';
        return this._httpClient.get<Translation>(`/assets/i18n/${lang}.json${version}`);
    }
}
